import React, { useEffect, useState } from 'react';
import styles from './Dropdown.module.scss';

export type DropdownProps = {
  title?: string;
  placeholder?: string;
  onValueChange: any;
  required?: false | true;
  options: any;
  isDisabled?: boolean;
  name?: string;
  handleChange?: any;
  handleBlur?: any;
  values?: any;
  isFieldInvalid?: boolean;
  onClick?: any;
  isDateWorkedEmpty?: boolean;
};

const Dropdown = ({
  title,
  onValueChange,
  required,
  options,
  placeholder,
  isDisabled = false,
  name,
  handleBlur,
  handleChange,
  values = undefined,
  isFieldInvalid,
  onClick,
  isDateWorkedEmpty,
}: DropdownProps) => {
  const [showError, setError] = useState<boolean>();

  const validateField = (value) => {
    if (value !== 'DEFAULT') {
      setError(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (isFieldInvalid) {
      setError(true);
    } else {
      setError(false)
    }
  }, [isFieldInvalid])

  return (
    // TODO add error prop + bool
    <div
      className={styles.Container}
      data-testid="Dropdown"
      onClick={onClick}
    >
      <label className={styles.ContainerLabel}>
        {title}
        {required ? <span className={styles.required}>*</span> : null}
      </label>
      <select
        name={name}
        value={values}
        disabled={isDisabled}
        placeholder={placeholder}
        className={
          (showError || isDateWorkedEmpty)
            ? styles.ContainerSelect + ' ' + styles.Error
            : styles.ContainerSelect
        }
        onChange={(event) => {
          if (handleChange) {
            handleChange(event)
          }
          onValueChange(event.target.value);

          name === 'state' && validateField(event.target.value);
        }}
        onBlur={(event) => {
          if (handleBlur) {
            handleBlur(event)
          }
          name === 'state' && validateField(event.target.value);
        }}
        defaultValue={'DEFAULT'}
      >
        <option disabled value={'DEFAULT'}>
          Please Select
        </option>
        {options.map((opt, i) => {
          return (
            <option key={i} value={opt.value}>
              {opt.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Dropdown;
